// extracted by mini-css-extract-plugin
export default {"container":"Button_container__XDNIn","disabled":"Button_disabled__z9pSC","title":"Button_title__tFO9Q"};